import React from 'react';
import PropTypes from 'prop-types';
import { EmojiIcon } from '../EmojiIcon';
import styles from './RiskConcernSummaryV2.css';

function RiskConcernSummaryV2({ score, chapterLabel, spriteVersion }) {
    return (
        <div className={styles.root}>
            <div className={styles.item}>
                <EmojiIcon name='target' version={spriteVersion} className={styles.emoji} />
                <div>
                    <p className={styles.label}>Life richness score</p>
                    <p className={styles.value}>{`${score}/100`}</p>
                </div>
            </div>
            <div className={styles.divider} />
            <div className={styles.item}>
                <EmojiIcon name='writing' version={spriteVersion} className={styles.emoji} />
                <div>
                    <p className={styles.label}>Starting with</p>
                    <p className={styles.value}>{chapterLabel}</p>
                </div>
            </div>
        </div>
    );
}

RiskConcernSummaryV2.propTypes = {
    score: PropTypes.number.isRequired,
    chapterLabel: PropTypes.string,
    spriteVersion: PropTypes.string.isRequired
};

export {
    RiskConcernSummaryV2
};
